import http from './http'
import createCatalogService from './catalogService'

export default {
  ...createCatalogService('/Telas/ContaLedger'),
  async getAccountTypeOptions () {
    const response = await http.get('/Telas/ContaLedger/GetAccountTypeOptions')
    return response.data
  },
  async getOwnerOptions () {
    const response = await http.get('/Telas/ContaLedger/GetOwnerOptions')
    return response.data
  },
  async getBankAccountOptions (ownerId) {
    const response = await http.get(`/Telas/ContaLedger/GetBankAccountOptions/${ownerId}`)
    return response.data
  }
}
